// Enhance real anchor links; native horizontal scrolling remains usable without JS.
function initCardRails(root = document) {
  root.querySelectorAll('.tn-card-rail').forEach((rail) => {
    if (rail.dataset.railReady) return;
    const scroller = rail.querySelector('.resource-list--grid');
    const links = [...rail.querySelectorAll('.tn-card-tabs a')];
    if (!scroller || !links.length) return;
    rail.dataset.railReady = 'true';
    const cards = [...scroller.querySelectorAll('.resource-list__item')];
    links.forEach((link, i) => link.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      cards[i]?.scrollIntoView({ block: 'nearest', inline: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    let pending = false;
    scroller.addEventListener('scroll', () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        const bounds = scroller.getBoundingClientRect();
        const rtl = getComputedStyle(scroller).direction === 'rtl';
        let nearest = 0, distance = Infinity;
        cards.forEach((card, i) => {
          const box = card.getBoundingClientRect();
          const delta = Math.abs(rtl ? box.right - bounds.right : box.left - bounds.left);
          if (delta < distance) { distance = delta; nearest = i; }
        });
        links.forEach((link, i) => link.setAttribute('aria-current', String(i === nearest)));
      });
    }, { passive: true });
  });
}
initCardRails();
document.addEventListener('shopify:section:load', (event) => initCardRails(event.target));
